/**
 * @file constants/companyConstants.js
 * @description CompanyAboutPage에 표시되는 정적 콘텐츠 데이터를 관리합니다.
 * 미션·비전, 핵심 역량, 규정 준수 배지 데이터를 정의합니다.
 */

import { Check, Handshake, Network, ShieldCheck } from 'lucide-react';

/* ── 미션 / 비전 / 핵심 가치 카드 ── */
export const missionVisionCards = [
  {
    Icon: ShieldCheck,
    iconClass: 'mission',
    no: '01',
    title: 'Mission',
    heading: '제조 현장의 신뢰를\n시스템으로 만듭니다',
    text: '칭량 오차를 줄이고, 제조 이력을 남기며, 현장에서 믿고 사용할 수 있는 운영 시스템을 구축합니다.',
  },
  {
    Icon: Network,
    iconClass: 'vision',
    no: '02',
    title: 'Vision',
    heading: '제약·화장품 제조 DX의\n기준이 됩니다',
    text: 'RWS · MES · WMS를 연결해 국내 제약·화장품 제조 현장에 최적화된 디지털 운영 환경을 만들어갑니다.',
  },
  {
    Icon: Handshake,
    iconClass: 'core',
    no: '03',
    title: 'Core Value',
    heading: '깊이 이해하고,\n끝까지 함께합니다',
    text: '현장의 업무 방식과 제약을 이해하고, 구축 이후 운영·유지보수까지 책임지는 파트너십을 지향합니다.',
  },
];

/* ── 핵심 역량 카드 ── */
export const capabilityCards = [
  {
    tag: 'Domain',
    title: '업종 전문성',
    text: 'GMP, CGMP, 화장품법 등 제약·화장품 규정 대응 경험을 시스템 설계에 직접 반영합니다.',
    kpiNum: '20년+',
    kpiLabel: '제약·화장품 도메인',
  },
  {
    tag: 'Platform',
    title: '3-in-1 통합 플랫폼',
    text: '칭량(RWS) · 제조(MES) · 창고(WMS)가 하나로 연결돼 데이터가 끊기지 않는 운영을 실현합니다.',
    kpiNum: '3-in-1',
    kpiLabel: 'RWS·MES·WMS',
  },
  {
    tag: 'Field',
    title: '현장 중심 구축',
    text: '현장 담당자의 언어와 업무 흐름에 맞게 설계하여 교육 부담과 운영 오류를 최소화합니다.',
    kpiNum: '100%',
    kpiLabel: '현장 인터뷰 기반',
  },
  {
    tag: 'Operate',
    title: '지속 운영 파트너',
    text: '도입 후에도 운영 이슈, 개선 요청, 법령 변경을 함께 대응하는 장기 파트너로 함께합니다.',
    kpiNum: '24/7',
    kpiLabel: '유지보수 대응',
  },
];

/* ── 인증 및 규정 준수 배지 목록 ── */
export const complianceBadges = [
  'GMP 적합',
  '식약처 기준 준수',
  '배치 추적 완결',
  'CSV / 전자서명 대응',
  '변경 이력 관리',
];

/** @type {typeof Check} Check 아이콘 — 배지 렌더링 시 사용 */
export { Check as CheckIcon };
